import merge from 'lodash/merge';

import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.youtubeApiUrl);
export const camelCaseAxios = createAxiosInstance(env.youtubeApiUrl, {
  camelizeKeys: true,
});

export async function getYouTubeChannel({ brandId }, axiosConfig = {}) {
  return camelCaseAxios.get(`/brands/${brandId}/channels/mine`, axiosConfig);
}

export async function getTrendingVideos({ brandId, startDate, endDate, limit }, axiosConfig = {}) {
  return axios.get(
    `/brands/${brandId}/videos/trending`,
    merge(
      {
        params: {
          startDate,
          endDate,
          limit,
        },
      },
      axiosConfig,
    ),
  );
}

export async function getPublicAccountsByIds({ sourceChannelIds }, axiosConfig = {}) {
  return camelCaseAxios.post('/competitors/public', { sourceChannelIds }, axiosConfig);
}

export async function getYouTubeSearchCounts(
  { topicQuery, bucket, fromDate, toDate },
  axiosConfig = {},
) {
  return axios.get(
    `/search/counts/`,
    merge(
      {
        params: {
          query: topicQuery,
          bucket,
          from_date: fromDate.replace('T', ' '),
          to_date: toDate.replace('T', ' '),
        },
      },
      axiosConfig,
    ),
  );
}

export async function getYouTubeRefreshAudienceStats(brandId, sourceVideoId, axiosConfig = {}) {
  return axios.patch(
    `/brands/${brandId}/refresh_audience_stats`,
    {
      video_id: sourceVideoId,
    },
    axiosConfig,
  );
}

export async function getYouTubeFeedVideos({ handle, limit, nextToken }, axiosConfig = {}) {
  return camelCaseAxios.get(
    `/channels/source/handles/${handle}`,
    merge(
      {
        params: {
          includeUploads: true,
          uploadsPageSize: limit,
          uploadsPageToken: nextToken,
        },
      },
      axiosConfig,
    ),
  );
}

export async function createMediaForVideo({ brandId, sourceVideoId }, axiosConfig = {}) {
  return camelCaseAxios.put(`/brands/${brandId}/public_videos/${sourceVideoId}`, {}, axiosConfig);
}
